import { server } from "@/api";

const prefix = 'api/video-calls'

export const rooms = {
    // Create a new video call room
    // data: { conversation_id: string, call_type: 'video'|'voice' }
    create: async (data) => {
        return await server().post(prefix + '/rooms', data)
    },

    // Get room details by ID
    // roomId: string
    get: async (roomId) => {
        return await server().get(prefix + '/rooms/' + roomId)
    },

    // End a video call room
    // roomId: string
    // data: { duration?: number, reason?: string }
    end: async (roomId, data = {}) => {
        return await server().post(prefix + '/rooms/' + roomId + '/end', data)
    },

    // Join a room (marks user as participant)
    // roomId: string
    join: async (roomId) => {
        return await server().post(prefix + '/rooms/' + roomId + '/join')
    },

    // Leave a room (marks user as left)
    // roomId: string
    leave: async (roomId) => {
        return await server().post(prefix + '/rooms/' + roomId + '/leave')
    },

    // Get room participants
    // roomId: string
    getParticipants: async (roomId) => {
        return await server().get(prefix + '/rooms/' + roomId + '/participants')
    }
}

export const calls = {
    // Initiate a video/voice call
    // data: { conversation_id: string, call_type: 'video'|'voice', metadata?: object }
    initiate: async (data) => {
        return await server().post(prefix + '/calls/initiate', data)
    },

    // Accept an incoming call
    // callId: string
    accept: async (callId) => {
        return await server().post(prefix + '/calls/' + callId + '/accept')
    },

    // Reject an incoming call
    // callId: string
    // data: { reason?: string }
    reject: async (callId, data = {}) => {
        return await server().post(prefix + '/calls/' + callId + '/reject', data)
    },

    // End an active call
    // callId: string
    // data: { duration?: number, reason?: string }
    end: async (callId, data = {}) => {
        return await server().post(prefix + '/calls/' + callId + '/end', data)
    },

    // Get call details
    // callId: string
    get: async (callId) => {
        return await server().get(prefix + '/calls/' + callId)
    }
}

const videoCallsApi = { rooms, calls }
export default videoCallsApi;
